// Generated by app/services/generate_js_env.rb

const railsEnv = {
  "API_CABLE_URL": "wss://api.wooftech.dk/cable",
  "API_URL": "https://api.wooftech.dk",
  "PEAKFLOW_JS_AUTH_TOKEN": "MdHHkcaZvNYw8kU9CRBQ77KxkiTsSshoh88uNTJVL5xpsvkDeFsofpqyrNuiUd4XiqAeXjjaVPESyLx3dnMjWoBrBp7W9a5yJD9Y",
  "PLAY_DOMAIN": "letswoof.io",
  "PLAY_DOMAIN_DA": "startwoof.dk",
  "PLAY_DOMAIN_EN": "letswoof.io",
  "PLAY_DOMAIN_NO": "startwoof.no",
  "PLAY_DOMAIN_SE": "startwoof.se",
  "PRODUCTFRUIT_CODE": "OdtlBiLje0GelYza",
  "RAILS_ENV": "production"
}
const env = {}

for (const key in railsEnv) {
  env[key] = globalThis[key] || railsEnv[key]
}

export default env
